import * as imageConversion from 'image-conversion'

export async function imageCompress(file: any, size: number = 300) {
  let name = file.name
  const blob = await imageConversion.compressAccurately(file, size)
  
  return new File([blob], name, { type: blob.type })
}